/**
 * PLAT-11898 — the transcript language a user last worked in, per story, so
 * reopening the story lands there instead of on the original. Persisted in
 * localStorage like `lastEditedClip`: it must survive the story list, the
 * Content Studio ⇄ Creator Studio navigation, and a reload. Per browser
 * profile, which is per user in practice — one person's language never
 * changes another's view, and no story record changes.
 *
 * A `lang` in the URL always wins over this; links neither read it nor write
 * it. Only a user's own pick writes here (hosts record on pick, not on
 * hydration), so opening someone's French link does not make French "mine".
 * `null` (Original) clears the entry. Best-effort: degrades silently when
 * storage is unavailable. Validation against the languages the story still
 * has is the reader's job, the same way the per-clip memory (PLAT-11748) is
 * checked at seed time.
 */

const keyFor = (storyId: string) => `arbor:lastStoryLanguage:${storyId}`;

export function recordLastStoryLanguage(
  storyId: string | undefined | null,
  language: string | null,
): void {
  if (!storyId) return;
  try {
    if (language) localStorage.setItem(keyFor(storyId), language);
    else localStorage.removeItem(keyFor(storyId));
  } catch {
    // localStorage unavailable / quota — the memory is best-effort.
  }
}

export function getLastStoryLanguage(
  storyId: string | undefined | null,
): string | null {
  if (!storyId) return null;
  try {
    return localStorage.getItem(keyFor(storyId));
  } catch {
    return null;
  }
}
